/**
 * @file 视频相关上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/video
 */
/* eslint-disable camelcase */
import request from './util/request';
import {
    camelToUnder
} from './util/json';
import configurable from './util/configurable';

import {Config} from './util/config';


/**
 * 数据上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
const report = configurable((json, callback) => {
    // 字段解析见 http://ewiki.baijiahulian.com//大数据团队/数据方向/大数据/旧项目文档/batch_event事件上报.md
    const {
        event_type = '3',

        // 设备id，也是区分用户的字段
        device_id,

        // 设备平台描述（ios/android）
        device_platform,

        // 设备操作系统
        device_os,

        // 设备名称
        device_model,

        // 区分批量上报的事件所属业务线或者上报主题
        topic = 'video_info',

        // 字段解析见 http://ewiki.baijiahulian.com/直播视频部/质量体系/接口.md
        event_attr,
        ...rest
    } = camelToUnder(json);

    // 补充其它必要上报数据
    const videokLogData = {
        // 当前页面 URL
        url: location.href,

        // 事件 id
        event_type,

        device_id,
        device_platform,
        device_os,
        device_model,
        topic,
        event_attr,
        ...rest
    };

    request('post')(`${Config.BATCH}`, '', callback, [videokLogData]);
}, {event_attr: {}});

export default report;
